
import {Component, Prop, Vue } from 'vue-property-decorator'
import { apiAllTagList } from '@/api/operating/group_welfare/tag'
@Component({})
export default class LabelSelect extends Vue{
  /** S Props*/
  @Prop() value: any
  /** E Props*/
  
  /** S Data*/
  loading = true
  tagList = []
  /** E Data*/
  
  /** S Computed*/
  get selectIds(): Array<number> {
    return this.value || []
  }
  set selectIds(value) {
    this.$emit('input', value)
  }
  /** E Computed*/
  
  /** S Methods*/
  select(item:any, groupId:number) {
    let arr = this.selectIds;
    let index = arr.indexOf(item.id)
    if (index < 0) {
      arr.push(item.id)
    } else {
      arr.splice(index, 1)
    }
    this.selectIds = arr
    this.checkSelectAll()
  }
  selectAll(checked:any, tag: any) {
    tag.map((item:any) => {
      let arr = this.selectIds;
      let index = arr.indexOf(item.id)
      if (checked) {
        if (index < 0) {
          arr.push(item.id)
        }
      } else {
        arr.splice(index, 1)
      }
      this.selectIds = arr
    })
  }
  checkSelectAll() {
    this.tagList.map((item: any) => {
      let ids = item.tag.map((i:any) => i.id)
      let select:any = [];
      ids.map((i:number) => {
         if (i && this.selectIds.length > 0 && this.selectIds.indexOf(i) >= 0) {
           select.push(i)
         }
       })
      if (select.length == ids.length && ids.length > 0 && select.length > 0) {
        item.checked = true
      } else {
        item.checked = false
      }
    })
  }
  /** E Methods*/
  created() {
    this.loading = true
    apiAllTagList().then(res => {
      this.tagList = res;
      this.loading = false
      this.checkSelectAll()
    })
  }
}
